"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryRequest = void 0;

var _query_pb = require("../proto/spine/client/query_pb");

var _filteringRequest = require("./filtering-request");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * A request to retrieve entities of the given type.
 *
 * Allows to post the query data to the Spine backend and receive the entity states as `Promise`.
 *
 * A usage example:
 * ```
 * const customers =
 *          client.select(Customer.class)
 *                .byId(westCoastCustomerIds())
 *                .withMask("name", "address", "email")
 *                .where([Filters.eq("type", "permanent"),
 *                       Filters.eq("discount_percent", 10),
 *                       Filters.eq("company_size", Company.Size.SMALL)])
 *                .orderBy("name", OrderBy.Direction.ASCENDING)
 *                .limit(20)
 *                .run(); // The returned type is `Promise<Customer[]>`.
 * ```
 *
 * All of the called filtering methods are optional. If none of them are specified, all entities
 * of type will be retrieved.
 *
 * @template <T> the query target type
 */
var QueryRequest = /*#__PURE__*/function (_FilteringRequest) {
  _inherits(QueryRequest, _FilteringRequest);

  var _super = _createSuper(QueryRequest);

  /**
   * @param {!Class<Message>} targetType the target type of entities
   * @param {!Client} client the client which initiated the request
   * @param {!ActorRequestFactory} actorRequestFactory the request factory
   */
  function QueryRequest(targetType, client, actorRequestFactory) {
    _classCallCheck(this, QueryRequest);

    return _super.call(this, targetType, client, actorRequestFactory);
  }
  /**
   * Sets the sorting order for the retrieved results.
   *
   * @param {!String} column the column to order by
   * @param {!OrderBy.Direction} direction the ascending/descending direction
   * @return {this} self for method chaining
   */


  _createClass(QueryRequest, [{
    key: "orderBy",
    value: function orderBy(column, direction) {
      if (direction === _query_pb.OrderBy.Direction.ASCENDING) {
        this._builder().orderAscendingBy(column);
      } else {
        this._builder().orderDescendingBy(column);
      }

      return this._self();
    }
    /**
     * Sets the maximum number of returned entities.
     *
     * Can only be used in conjunction with the {@link #orderBy} condition.
     *
     * @param {number} count the max number of response entities
     * @return {this} self for method chaining
     */

  }, {
    key: "limit",
    value: function limit(count) {
      this._builder().limit(count);

      return this._self();
    }
    /**
     * Builds a `Query` instance based on currently specified filters.
     *
     * @return {spine.client.Query} a `Query` instance
     */

  }, {
    key: "query",
    value: function query() {
      return this._builder().build();
    }
    /**
     * Runs the query and obtains the results.
     *
     * @return {Promise<Message[]>} the asynchronously resolved query results
     */

  }, {
    key: "run",
    value: function run() {
      var query = this.query();
      return this._client.read(query);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_newBuilderFn",
    value: function _newBuilderFn() {
      var _this = this;

      return function (requestFactory) {
        return requestFactory.query().select(_this.targetType);
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_self",
    value: function _self() {
      return this;
    }
  }]);

  return QueryRequest;
}(_filteringRequest.FilteringRequest);

exports.QueryRequest = QueryRequest;
//# sourceMappingURL=query-request.js.map